module.exports = __webpack_public_path__ + "img/pscBox32.dbf73bf5.png";